import { cn } from 'support/helpers/cn/cn';

const sizeClasses: Record<SidebarBadgeProps['size'], string> = {
  small: 'absolute -right-0.5 -bottom-0.5 px-1.5',
  normal: 'px-2.5 py-0.5',
};

const variantClasses: Record<SidebarBadgeProps['variant'], string> = {
  notification: 'bg-red-600 text-white',
  new: 'bg-purple-50 border border-purple-100 text-purple-800',
};

type SidebarBadgeProps = {
  content: string | number;
  size: 'small' | 'normal';
  variant: 'notification' | 'new';
};

export const SidebarBadge = ({ content, size, variant }: SidebarBadgeProps) => {
  return content ? (
    <div className={cn('flex flex-row rounded-full text-xs font-semibold', sizeClasses[size], variantClasses[variant])}>
      <span>{content}</span>
    </div>
  ) : null;
};
